import { configApiRef, useApi } from '@backstage/frontend-plugin-api';

/**
 * Returns the branding logo URL from app config (`branding.logoUrl`),
 * or `undefined` when not configured.
 */
export const useBrandingLogoUrl = (): string | undefined => {
  const config = useApi(configApiRef);
  return config.getOptionalString('branding.logoUrl');
};
